<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT © {{ new Date().getFullYear() }}
      <b-link class="ml-25" href="https://vue.co.ke" target="_blank"
        >Kericho County Government</b-link
      >
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>

    <version />
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import Version from '@/components/misc/Version.vue'

export default {
  components: {
    BLink,
    Version,
  },
}
</script>
